export type DirectoryRegion = {
  slug: string;
  name: string;
  canton: string;
  locations: string[];
  contractorAdvice: string;
  agentAdvice: string;
};

// Canton pages keep a clear scope: a provider's published location is not a
// promise that it serves every municipality in that canton.
export const directoryRegions: DirectoryRegion[] = [
  {
    slug: "aargau",
    name: "Aargau",
    canton: "ag",
    locations: ["Aarau", "Baden", "Brugg", "Wohlen", "Zofingen"],
    contractorAdvice:
      "Zwischen Aarau, Baden und dem Freiamt können Anfahrtswege deutlich variieren. Vergleichen Sie bei Renovationen neben dem Arbeitsumfang auch Anfahrt, Baustelleneinrichtung und die Koordination mehrerer Gewerke.",
    agentAdvice:
      "Eine Wohnung in Baden und ein Einfamilienhaus im Freiamt sprechen unterschiedliche Käufer an. Lassen Sie sich Referenzen aus der jeweiligen Teilregion zeigen und fragen Sie, wie der Makler Pendlerlage, Grundstück und Objektzustand in der Vermarktung berücksichtigt.",
  },
  {
    slug: "appenzell-ausserrhoden",
    name: "Appenzell Ausserrhoden",
    canton: "ar",
    locations: ["Herisau", "Teufen", "Heiden"],
    contractorAdvice:
      "Bei traditionellen Appenzellerhäusern sind Erfahrung mit Holz, Schindelfassaden und bestehenden Bauteilen hilfreich. Fragen Sie Betriebe nach ähnlichen Arbeiten und danach, welche Vorabklärungen sie vor einer verbindlichen Offerte benötigen.",
    agentAdvice:
      "Für ein Appenzellerhaus sind andere Vergleichsobjekte sinnvoll als für eine neue Eigentumswohnung. Fragen Sie nach Erfahrung mit dem jeweiligen Gebäudetyp sowie nach der Darstellung von Unterhalt, Grundstück und Erreichbarkeit.",
  },
  {
    slug: "appenzell-innerrhoden",
    name: "Appenzell Innerrhoden",
    canton: "ai",
    locations: ["Appenzell", "Gonten", "Schwende-Rüte"],
    contractorAdvice:
      "Bei Häusern im Dorfkern und bei freistehenden Gebäuden unterscheiden sich Platz und Zufahrt. Klären Sie mit dem Betrieb, wie Materialtransport, Gerüste und Arbeiten an bestehenden Holzbauteilen organisiert werden.",
    agentAdvice:
      "Bei ländlichen Liegenschaften sollten Grundstück, Nutzung und baulicher Zustand verständlich dokumentiert sein. Besprechen Sie mit dem Makler, welche Unterlagen für Ihr konkretes Objekt noch fehlen und welche Käufergruppe er ansprechen würde.",
  },
  {
    slug: "basel-landschaft",
    name: "Basel-Landschaft",
    canton: "bl",
    locations: ["Liestal", "Pratteln", "Muttenz", "Reinach", "Sissach"],
    contractorAdvice:
      "Im Baselbiet lohnt sich bei einer Haussanierung die Abstimmung von Heizung, Gebäudehülle und Innenausbau. Fragen Sie nach Referenzen für bewohnte Einfamilienhäuser und vergleichen Sie, wer Schnittstellen und Bauablauf übernimmt.",
    agentAdvice:
      "Agglomerationsgemeinden bei Basel und das obere Baselbiet haben unterschiedliche Einzugsgebiete. Achten Sie bei der Maklerwahl auf Referenzen in Ihrer Gemeinde und eine nachvollziehbare Begründung der vorgeschlagenen Vermarktung.",
  },
  {
    slug: "basel-stadt",
    name: "Basel-Stadt",
    canton: "bs",
    locations: ["Basel", "Riehen", "Bettingen"],
    contractorAdvice:
      "In dicht bebauten Basler Quartieren sind Parkmöglichkeiten, Lieferzeiten und der Zugang über Treppenhäuser Teil der Planung. Lassen Sie diese Positionen bei Altbau- und Wohnungsrenovationen in der Offerte ausdrücklich aufführen.",
    agentAdvice:
      "Bei Basler Stadtwohnungen lohnt sich ein Vergleich auf Quartier- und Objektebene. Fragen Sie nach Referenzen für ähnliche Wohnungen und danach, wie Stockwerkeigentum, Renovationsbedarf und laufende Kosten im Dossier erklärt werden.",
  },
  {
    slug: "bern",
    name: "Bern",
    canton: "be",
    locations: ["Bern", "Thun", "Biel/Bienne", "Burgdorf", "Interlaken"],
    contractorAdvice:
      "Der Kanton reicht von städtischen Wohnungen bis zu Häusern im Oberland. Prüfen Sie den tatsächlichen Einsatzradius des Betriebs und fragen Sie bei längeren Wegen nach Anfahrt, Etappierung und einer Kontaktperson vor Ort.",
    agentAdvice:
      "Ein Makler mit Schwerpunkt Berner Stadtwohnungen passt nicht automatisch zu einem Chalet im Oberland. Vergleichen Sie Referenzen nach Teilregion und Objekttyp; im Raum Biel kann zusätzlich eine zweisprachige Vermarktung relevant sein.",
  },
  {
    slug: "freiburg",
    name: "Freiburg",
    canton: "fr",
    locations: ["Freiburg", "Bulle", "Murten", "Düdingen"],
    contractorAdvice:
      "Im Sense- und Seebezirk sowie rund um Freiburg arbeiten Betriebe in unterschiedlichen Sprachen. Vereinbaren Sie die Sprache für Offerte und Bauabsprachen und klären Sie, wer die Arbeiten vor Ort koordiniert.",
    agentAdvice:
      "Fragen Sie im zweisprachigen Kanton, in welchen Sprachen Dossier, Besichtigungen und Interessentenbetreuung angeboten werden. Referenzen aus dem Sensebezirk, dem Seebezirk oder dem Greyerzerland helfen, die regionale Erfahrung einzuordnen.",
  },
  {
    slug: "genf",
    name: "Genf",
    canton: "ge",
    locations: ["Genf", "Carouge", "Vernier", "Lancy"],
    contractorAdvice:
      "Bei Arbeiten in bewohnten Genfer Mehrfamilienhäusern sind Zugang, Lärmzeiten und die Abstimmung mit der Verwaltung wichtig. Fragen Sie, ob der Betrieb französischsprachige Offerten erstellt und wie er gemeinsame Gebäudeteile schützt.",
    agentAdvice:
      "Für Wohnungen in Genf sollten Sie die Erfahrung mit dem konkreten Quartier und der passenden Käufergruppe prüfen. Besprechen Sie auch, in welchen Sprachen Besichtigungen möglich sind und wie der Makler Anfragen dokumentiert.",
  },
  {
    slug: "glarus",
    name: "Glarus",
    canton: "gl",
    locations: ["Glarus", "Glarus Nord", "Glarus Süd"],
    contractorAdvice:
      "Bei älteren Glarner Wohn- und Gewerbebauten sollten bestehende Leitungen und Bauteile vor der Offerte besichtigt werden. Fragen Sie, welche Annahmen der Preis enthält und wie zusätzliche Arbeiten freigegeben werden.",
    agentAdvice:
      "Bei ehemaligen Gewerbe- oder älteren Wohnbauten sind Zustand und aktuelle Nutzung besonders erklärungsbedürftig. Lassen Sie sich zeigen, wie der Makler solche Objekte dokumentiert und welche Vergleichsverkäufe er für die Einordnung heranzieht.",
  },
  {
    slug: "graubuenden",
    name: "Graubünden",
    canton: "gr",
    locations: ["Chur", "Davos", "St. Moritz", "Ilanz", "Thusis"],
    contractorAdvice:
      "In Bündner Tälern beeinflussen Distanz, Höhenlage und saisonaler Zugang den Ablauf. Vergleichen Sie Anbieter nach Erfahrung am Objektstandort und klären Sie Transport, Lagerung und das Zeitfenster für Aussenarbeiten.",
    agentAdvice:
      "Wohnimmobilien in Chur und Ferienobjekte in Bergorten brauchen unterschiedliche Vermarktung. Fragen Sie nach lokalen Referenzen, Betreuung bei Ihrer Abwesenheit und den objektspezifischen Abklärungen, die vor dem Verkauf nötig sind.",
  },
  {
    slug: "jura",
    name: "Jura",
    canton: "ju",
    locations: ["Delsberg", "Pruntrut", "Saignelégier"],
    contractorAdvice:
      "Bei ländlichen Liegenschaften im Jura sollten Zufahrt und Arbeitsumfang früh besichtigt werden. Prüfen Sie, ob der Betrieb Offerte und Terminabsprachen auf Französisch abwickelt und wie längere Anfahrten berechnet werden.",
    agentAdvice:
      "Für ein Haus in der Ajoie oder in den Freibergen ist Erfahrung mit ländlichen Objekten hilfreich. Fragen Sie nach französischsprachiger Betreuung und danach, wie Grundstück, Nebengebäude und Unterhaltszustand im Exposé dargestellt werden.",
  },
  {
    slug: "luzern",
    name: "Luzern",
    canton: "lu",
    locations: ["Luzern", "Kriens", "Emmen", "Sursee", "Hochdorf"],
    contractorAdvice:
      "Bei Wohnungsumbauten im Raum Luzern und bei Häusern auf der Landschaft unterscheiden sich Logistik und Koordination. Fragen Sie bei Stockwerkeigentum nach dem Schutz gemeinsamer Bereiche und nach einer klaren Terminplanung.",
    agentAdvice:
      "Stadtwohnungen, Seelagen und Häuser in ländlichen Gemeinden sollten mit passenden Referenzobjekten verglichen werden. Fragen Sie den Makler, welche Teilregionen er betreut und wie er die Besonderheiten Ihres Objekts belegt.",
  },
  {
    slug: "neuenburg",
    name: "Neuenburg",
    canton: "ne",
    locations: ["Neuenburg", "La Chaux-de-Fonds", "Le Locle"],
    contractorAdvice:
      "Bei älteren Stadtwohnungen und Häusern im Jurabogen sind Leitungszustand und die Planung von Aussenarbeiten wichtige Vergleichspunkte. Bitten Sie um Referenzen mit ähnlicher Bausubstanz und eine schriftliche Abgrenzung der Leistungen.",
    agentAdvice:
      "Die Lage am See und die Städte im oberen Kanton sprechen unterschiedliche Interessenten an. Fragen Sie nach französischsprachigen Dossiers und konkreten Referenzen für Ihren Standort und Gebäudetyp.",
  },
  {
    slug: "nidwalden",
    name: "Nidwalden",
    canton: "nw",
    locations: ["Stans", "Hergiswil", "Buochs", "Ennetbürgen"],
    contractorAdvice:
      "Bei Häusern in Hanglage und am See sollten Sie Zugang und Materialtransport mit dem Betrieb besprechen. Vergleichen Sie, ob Gerüste, Hebemittel und Schutz bestehender Aussenanlagen im Angebot enthalten sind.",
    agentAdvice:
      "Aussicht, Erschliessung und die konkrete Mikrolage können bei Nidwaldner Objekten wichtige Vergleichspunkte sein. Lassen Sie sich erklären, wie diese Eigenschaften im Dossier dokumentiert und im vorgeschlagenen Verkaufspreis begründet werden.",
  },
  {
    slug: "obwalden",
    name: "Obwalden",
    canton: "ow",
    locations: ["Sarnen", "Kerns", "Sachseln", "Engelberg"],
    contractorAdvice:
      "Bei älteren Holzhäusern und Ferienobjekten lohnt sich eine Besichtigung vor der Offerte. Klären Sie bei abgelegenen Standorten, wer Zugang organisiert und welche Arbeiten witterungsabhängig geplant werden müssen.",
    agentAdvice:
      "Ein Ferienobjekt in Engelberg und ein Familienhaus im Sarneraatal haben unterschiedliche Zielgruppen. Vergleichen Sie Makler nach passenden Referenzen und danach, wie sie Besichtigungen bei abwesenden Eigentümern organisieren.",
  },
  {
    slug: "schaffhausen",
    name: "Schaffhausen",
    canton: "sh",
    locations: ["Schaffhausen", "Neuhausen am Rheinfall", "Stein am Rhein"],
    contractorAdvice:
      "Bei Altstadthäusern und schmalen Zufahrten sind Baustellenlogistik und der Schutz bestehender Bauteile wichtig. Fragen Sie nach Erfahrung mit ähnlichen Objekten und lassen Sie benötigte Abklärungen vor Arbeitsbeginn festhalten.",
    agentAdvice:
      "Für historische Stadthäuser sollten Modernisierungen und noch offene Unterhaltsarbeiten verständlich dargestellt werden. Fragen Sie nach Erfahrung in Ihrer Gemeinde und nach der Aufbereitung von Flächen, Grundrissen und Nebenkosten.",
  },
  {
    slug: "schwyz",
    name: "Schwyz",
    canton: "sz",
    locations: ["Schwyz", "Einsiedeln", "Küssnacht", "Freienbach", "Lachen"],
    contractorAdvice:
      "Zwischen dem Talkessel, Einsiedeln und dem äusseren Kanton unterscheiden sich Anfahrt und Baustellenlage. Prüfen Sie, ob der Betrieb Ihren Standort regelmässig betreut und wie Arbeiten in Hanglagen organisiert werden.",
    agentAdvice:
      "Höfe, March, Einsiedeln und der innere Kanton sind unterschiedliche Teilmärkte. Fragen Sie nach Referenzen aus Ihrer Teilregion und lassen Sie sich erklären, wie der Makler den Kreis möglicher Käufer eingrenzt.",
  },
  {
    slug: "solothurn",
    name: "Solothurn",
    canton: "so",
    locations: ["Solothurn", "Olten", "Grenchen", "Dornach"],
    contractorAdvice:
      "Vom Wasseramt bis ins Schwarzbubenland sind die Einsatzgebiete der Betriebe unterschiedlich. Vergleichen Sie bei Sanierungen die Anfahrtskosten und fragen Sie, ob Besichtigung, Entsorgung und Abschlussreinigung enthalten sind.",
    agentAdvice:
      "Ein Objekt im Raum Olten und eines in Dornach erreicht oft andere Interessenten. Prüfen Sie die Erfahrung des Maklers im jeweiligen Bezirk und fragen Sie nach einer objektspezifischen Vermarktung statt einer allgemeinen Kantonsbewertung.",
  },
  {
    slug: "st-gallen",
    name: "St. Gallen",
    canton: "sg",
    locations: ["St. Gallen", "Wil", "Rapperswil-Jona", "Buchs", "Sargans"],
    contractorAdvice:
      "Der Kanton umfasst mehrere weit auseinanderliegende Regionen. Fragen Sie ausdrücklich nach dem Einsatzgebiet und lassen Sie Anfahrt, Terminfenster und Zuständigkeit bei Nacharbeiten schriftlich bestätigen.",
    agentAdvice:
      "Stadt St. Gallen, Rheintal und Zürichseegebiet unterscheiden sich in Lage und Käuferkreis. Vergleichen Sie Makler anhand von Referenzen aus Ihrer Region und fragen Sie, wer Besichtigungen persönlich durchführt.",
  },
  {
    slug: "tessin",
    name: "Tessin",
    canton: "ti",
    locations: ["Lugano", "Bellinzona", "Locarno", "Mendrisio"],
    contractorAdvice:
      "Bei Rustici und Ferienwohnungen ist die Organisation vor Ort oft entscheidend. Vereinbaren Sie die Sprache der Offerte, die Schlüsselübergabe und die Dokumentation der Arbeiten, wenn Sie während des Umbaus nicht anwesend sind.",
    agentAdvice:
      "Für Ferienwohnungen, Rustici und dauerhaft bewohnte Häuser sind unterschiedliche Erfahrungen gefragt. Klären Sie italienischsprachige Betreuung, Besichtigungen bei Ihrer Abwesenheit und die für das konkrete Objekt erforderlichen Unterlagen.",
  },
  {
    slug: "thurgau",
    name: "Thurgau",
    canton: "tg",
    locations: ["Frauenfeld", "Kreuzlingen", "Weinfelden", "Arbon", "Romanshorn"],
    contractorAdvice:
      "Bei der Sanierung von Einfamilien- und Bauernhäusern sollten Gebäudehülle und Haustechnik gemeinsam betrachtet werden. Fragen Sie Anbieter nach der Reihenfolge der Arbeiten und nach Referenzen für den jeweiligen Gebäudetyp.",
    agentAdvice:
      "Seenahe Wohnungen und ländliche Häuser benötigen passende Vergleichsobjekte. Fragen Sie nach Erfahrung im jeweiligen Bezirk und danach, wie Unterhaltsbedarf, Grundstück und Anbindung im Verkaufsdossier beschrieben werden.",
  },
  {
    slug: "uri",
    name: "Uri",
    canton: "ur",
    locations: ["Altdorf", "Schattdorf", "Erstfeld", "Andermatt"],
    contractorAdvice:
      "Bei Baustellen in Seitentälern oder höher gelegenen Orten können Anfahrt und Materiallieferung den Aufwand prägen. Klären Sie früh, welche Transporte und Wetterreserven die Offerte berücksichtigt.",
    agentAdvice:
      "Ein Wohnhaus im Talboden und ein Ferienobjekt in Andermatt sprechen unterschiedliche Käufer an. Fragen Sie nach Erfahrung am Objektstandort und danach, wie Besichtigungen sowie objektspezifische Abklärungen organisiert werden.",
  },
  {
    slug: "waadt",
    name: "Waadt",
    canton: "vd",
    locations: ["Lausanne", "Nyon", "Vevey", "Montreux", "Yverdon-les-Bains"],
    contractorAdvice:
      "Zwischen Genfersee und nördlichem Kantonsgebiet sind Anfahrtswege ein wichtiger Vergleichspunkt. Fragen Sie nach französischsprachigen Offerten und lassen Sie Leistung, Material und Entsorgung einzeln beschreiben.",
    agentAdvice:
      "La Côte, Lausanne, Riviera und Nordwaadt sind unterschiedliche Suchgebiete. Prüfen Sie Referenzen aus der passenden Teilregion und klären Sie, in welchen Sprachen der Makler Dossier und Interessentenbetreuung anbietet.",
  },
  {
    slug: "wallis",
    name: "Wallis",
    canton: "vs",
    locations: ["Sitten", "Siders", "Visp", "Brig-Glis", "Martigny"],
    contractorAdvice:
      "Talorte und Berggemeinden stellen unterschiedliche Anforderungen an Zugang und Saisonplanung. Fragen Sie nach Erfahrung am Standort sowie nach der Sprache für Bauabsprachen und lassen Sie Transportkosten konkret ausweisen.",
    agentAdvice:
      "Im Ober- und Unterwallis sowie in Ferienorten unterscheiden sich Sprache und Käuferkreis. Vergleichen Sie Makler nach lokaler Erfahrung und klären Sie, wer das Objekt betreut, wenn Sie selbst nicht vor Ort wohnen.",
  },
  {
    slug: "zug",
    name: "Zug",
    canton: "zg",
    locations: ["Zug", "Baar", "Cham", "Rotkreuz", "Unterägeri"],
    contractorAdvice:
      "Bei Wohnungsumbauten und hochwertigem Innenausbau lohnt sich eine genaue Material- und Ausführungsbeschreibung. Vergleichen Sie Bemusterung, Schutzmassnahmen und Abnahmetermine statt nur den Gesamtpreis.",
    agentAdvice:
      "Bei Eigentumswohnungen und Häusern sollten Lage, Ausbau und laufende Kosten im Vergleich nachvollziehbar sein. Fragen Sie nach Referenzen in Ihrer Gemeinde und einer begründeten Preisstrategie für Ihr konkretes Objekt.",
  },
  {
    slug: "zuerich",
    name: "Zürich",
    canton: "zh",
    locations: ["Zürich", "Winterthur", "Uster", "Wetzikon", "Bülach"],
    contractorAdvice:
      "Stadtwohnungen und Häuser im Zürcher Oberland brauchen unterschiedliche Baustellenabläufe. Fragen Sie nach verfügbaren Terminen, Park- und Liefermöglichkeiten und der Abstimmung mit Verwaltung oder Eigentümergemeinschaft.",
    agentAdvice:
      "Stadt Zürich, Winterthur und die Landregionen sollten anhand passender Vergleichsobjekte beurteilt werden. Lassen Sie sich Referenzen für Ihr Quartier oder Ihre Gemeinde zeigen und fragen Sie nach einer nachvollziehbaren Preis- und Vermarktungsstrategie.",
  },
];

export type DirectorySpecialty = {
  slug: string;
  name: string;
  terms: string[];
  intro: string;
  checks: string[];
};

export const directoryTrades: DirectorySpecialty[] = [
  {
    slug: "bauunternehmen",
    name: "Bauunternehmen",
    terms: [
      "bauunternehmen",
      "generalunternehmen",
      "totalunternehmen",
      "baumeister",
      "construction",
      "bauleitung",
      "renovation",
      "umbau",
    ],
    intro:
      "Vergleichen Sie Bauunternehmen für Umbau, Renovation und die Koordination mehrerer Gewerke. Entscheidend ist, welche Planungs- und Ausführungsleistungen das Unternehmen selbst übernimmt.",
    checks: [
      "Referenzen für Projekte mit ähnlichem Umfang besichtigen.",
      "Bauleitung, Subunternehmen und Ansprechpartner festlegen.",
      "Leistungsbeschrieb, Etappen und Umgang mit Nachträgen schriftlich klären.",
    ],
  },
  {
    slug: "maler",
    name: "Maler & Gipser",
    terms: ["maler", "gipser", "verputz", "tapezier", "peinture"],
    intro:
      "Finden Sie Betriebe für Anstriche, Verputz und Fassadenarbeiten. Ein vergleichbares Angebot beschreibt Untergrund, Vorbereitung, Anzahl Anstriche und die vorgesehenen Produkte.",
    checks: [
      "Flächen und Zustand des Untergrunds gemeinsam aufnehmen.",
      "Abdecken, Spachteln und Entsorgung in der Offerte prüfen.",
      "Farbmuster, Material und Ausführungstermin vereinbaren.",
    ],
  },
  {
    slug: "sanitaer",
    name: "Sanitär & Heizung",
    terms: ["sanitär", "sanitaer", "heizung", "wärmepumpe", "plomb", "chauffage"],
    intro:
      "Vergleichen Sie Sanitär- und Heizungsbetriebe für Badumbau, Leitungen oder Heizungsersatz. Fragen Sie gezielt nach Erfahrung mit der bestehenden Anlage und dem gewünschten System.",
    checks: [
      "Bestehende Leitungen und Anschlüsse vor Ort prüfen lassen.",
      "Demontage, Montage und Inbetriebnahme getrennt ausweisen lassen.",
      "Wartung, Dokumentation und Ansprechpartner nach der Übergabe klären.",
    ],
  },
  {
    slug: "elektriker",
    name: "Elektriker",
    terms: ["elektr", "ladestation", "photovoltaik"],
    intro:
      "Suchen Sie Elektrofirmen für Installationen, Beleuchtung und Erweiterungen im Haus. Beschreiben Sie vorhandene Anschlüsse und fragen Sie nach den für die Arbeit nötigen Kontrollen und Nachweisen.",
    checks: [
      "Installationsumfang und vorhandene Verteilung besichtigen lassen.",
      "Material, Leitungswege und Wiederherstellung der Oberflächen klären.",
      "Messungen, Kontrollen und Dokumentation in der Offerte prüfen.",
    ],
  },
  {
    slug: "bodenleger",
    name: "Bodenleger & Parkett",
    terms: ["boden", "parkett", "plattenleg", "carrelage"],
    intro:
      "Vergleichen Sie Fachbetriebe für Parkett, Bodenbeläge und Plattenarbeiten. Neben dem Belag bestimmen Untergrund, Aufbauhöhe und Übergänge den tatsächlichen Aufwand.",
    checks: [
      "Untergrund und nötige Vorarbeiten gemeinsam beurteilen.",
      "Materialmuster, Sockelleisten und Türanschlüsse abstimmen.",
      "Ausbau alter Beläge, Entsorgung und Pflegehinweise einbeziehen.",
    ],
  },
  {
    slug: "dachdecker",
    name: "Dachdecker & Spengler",
    terms: ["dach", "spengler", "abdichtung", "couvreur"],
    intro:
      "Finden Sie Betriebe für Dachunterhalt, Neueindeckung und Spenglerarbeiten. Für einen belastbaren Vergleich sollten Dachzustand, Gerüst und Anschlüsse im gleichen Leistungsumfang enthalten sein.",
    checks: [
      "Dachflächen, Anschlüsse und Entwässerung besichtigen lassen.",
      "Gerüst, Wetterschutz und Entsorgung in der Offerte prüfen.",
      "Fotodokumentation und Abstimmung mit Dämmung oder Solaranlage klären.",
    ],
  },
  {
    slug: "schreiner",
    name: "Schreiner & Fenster",
    terms: ["schreiner", "fenster", "tischler", "holzbau", "menuis"],
    intro:
      "Vergleichen Sie Schreinereien für Einbauten, Türen und Fenster. Masse, Beschläge, Material und Montageumfang sollten feststehen, bevor Sie Angebote gegenüberstellen.",
    checks: [
      "Ausmass und Materialbemusterung vor der Fertigung vereinbaren.",
      "Beschläge, Oberflächen und Anschlussdetails schriftlich festhalten.",
      "Demontage, Montage und Ausbesserungen bestehender Flächen abgrenzen.",
    ],
  },
  {
    slug: "gartenbau",
    name: "Gartenbau",
    terms: ["garten", "landschaft", "gärtner", "gaertner", "paysag"],
    intro:
      "Finden Sie Gartenbaubetriebe für Gestaltung, Bepflanzung und Unterhalt. Ein gutes Angebot berücksichtigt Boden, Zugang für Maschinen und die Pflege nach Abschluss der Arbeiten.",
    checks: [
      "Flächen, Gelände und Zufahrt gemeinsam aufnehmen.",
      "Erdarbeiten, Abtransport und Materialmengen vergleichen.",
      "Bepflanzung, Bewässerung und anschliessende Pflege klären.",
    ],
  },
  {
    slug: "reinigung",
    name: "Reinigungsfirmen",
    terms: ["reinig", "nettoy", "pulizia", "cleaning"],
    intro:
      "Vergleichen Sie Reinigungsfirmen für Umzug, Bauabschluss und regelmässigen Unterhalt. Legen Sie fest, welche Räume und Flächen dazugehören und welche Leistungen separat berechnet werden.",
    checks: [
      "Fenster, Storen, Geräte und Nebenräume ausdrücklich aufführen.",
      "Bei Umzügen Umfang und Bedingungen einer Abnahmegarantie prüfen.",
      "Schlüsselübergabe, Termin und Vorgehen bei Nachreinigung vereinbaren.",
    ],
  },
  {
    slug: "raeumung",
    name: "Räumung & Rückbau",
    terms: [
      "räum",
      "raeum",
      "rückbau",
      "rueckbau",
      "entkern",
      "abbruch",
      "demol",
      "débarr",
      "sgomber",
    ],
    intro:
      "Finden Sie Unternehmen für Wohnungsräumungen, Abbruch und Rückbau sowie Demontage und Entkernung. Vergleichen Sie Firmen nach Referenzen für Hausrückbau, Badrückbau oder Industrierückbau. Für eine Gebäudeentkernung oder die Entkernung einer Wohnung prüfen Sie die Erfahrung der Entkernungsfirma und klären Sie Umfang und Entsorgung direkt mit dem Anbieter.",
    checks: [
      "Räumungsumfang und zu erhaltende Gegenstände vor Ort festlegen.",
      "Transport, Entsorgung und besondere Materialien einzeln klären.",
      "Schutz gemeinsamer Flächen und Zustand bei Übergabe vereinbaren.",
    ],
  },
];

export const agentServices: DirectorySpecialty[] = [
  {
    slug: "hausverkauf",
    name: "Hausverkauf",
    terms: ["hausverkauf", "immobilienverkauf", "verkauf", "vermarktung", "vente", "vendita"],
    intro:
      "Ein Hausverkauf braucht einen Makler, der Grundstück, Gebäudezustand und Käufergruppe zusammen betrachtet. Vergleichen Sie Referenzen für ähnliche Häuser und lassen Sie sich den geplanten Verkaufsablauf erklären.",
    checks: [
      "Referenzen für Einfamilienhäuser und die betreute Region vergleichen.",
      "Bewertungsgrundlage, Dossier und Besichtigungsablauf besprechen.",
      "Provision, Zusatzkosten, Laufzeit und Kündigung des Mandats schriftlich prüfen.",
    ],
  },
  {
    slug: "wohnungsverkauf",
    name: "Wohnungsverkauf",
    terms: ["wohnungsverkauf", "immobilienverkauf", "verkauf", "vermarktung", "vente", "vendita"],
    intro:
      "Für den Verkauf einer Eigentumswohnung zählen neben Lage und Grundriss auch die Unterlagen zum Stockwerkeigentum. Fragen Sie Makler, wie sie laufende Kosten, Erneuerungsfonds und geplante Arbeiten für Interessenten aufbereiten.",
    checks: [
      "Referenzen für vergleichbare Eigentumswohnungen prüfen.",
      "Reglement, Protokolle und Angaben zu laufenden Kosten zusammentragen.",
      "Leistungen, Provision und Berichterstattung während des Verkaufs vereinbaren.",
    ],
  },
  {
    slug: "immobilienbewertung",
    name: "Immobilienbewertung",
    terms: ["bewertung", "marktwert", "schätzung", "schaetzung", "estimation", "valutazione"],
    intro:
      "Eine nachvollziehbare Immobilienbewertung legt Annahmen und Datengrundlage offen. Vergleichen Sie Anbieter danach, ob sie Ihr Objekt besichtigen und Zustand, Lage und passende Vergleichsobjekte in einer verständlichen Begründung zusammenführen.",
    checks: [
      "Zweck der Bewertung und Umfang des schriftlichen Berichts klären.",
      "Nach Methode, Vergleichsobjekten und Umgang mit Sanierungsbedarf fragen.",
      "Kosten und eine allfällige Bindung an ein Verkaufsmandat vorab prüfen.",
    ],
  },
];

export const getDirectoryRegion = (slug: string) => directoryRegions.find((r) => r.slug === slug);
export const getDirectoryTrade = (slug: string) => directoryTrades.find((t) => t.slug === slug);
export const getAgentService = (slug: string) => agentServices.find((s) => s.slug === slug);
